/** organization roles parata internal employees & pharmacy managers (client) */
export enum Role {
  implementationMgr = 'IM',
  pharmacy = 'PM',
  admin = 'AU',
  inventorySpecialist = 'InventorySpecialist',
  reportViewer = 'ReportViewer',
  sdsUser = 'SDS User',
  rpo = 'RPO',
  parataDev = 'Parata Dev',
  orgAdmin = 'OrgAdmin',
  ert = 'CDDB Viewer',
  sdsManager = 'SDS Manager'
}
